module.exports = __webpack_public_path__ + "static/media/qrcode_icon.4b63617e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/qrcode_icon.svg
// module id = 326
// module chunks = 2